import React, { useState, useRef } from 'react';
import { useOutside } from 'hooks';
import { Text } from 'styles';
import { Icon } from 'components/common/Icon';
import * as S from './DropdownStyle';

export function Dropdown({
  list,
  disabled,
  name,
  label,
  placeholder,
  value,
  onChange,
  $flex,
  $maxHeight,
  $font,
  ...props
}) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef();

  useOutside([dropdownRef], () => setOpen(false));

  const handleOnChange = (item) => {
    onChange(name, item.value);
    setOpen(false);
  };

  return (
    <S.Warp $label={label} $flex={$flex}>
      {label && <Text>{label}</Text>}
      <S.Container ref={dropdownRef} $flex={$flex}>
        <label htmlFor={`drop_${name}`}>
          <S.DropBox
            open={open}
            value={value}
            disabled={disabled}
            onClick={() => !disabled && setOpen(!open)}
            {...props}
          >
            <Text $type={$font || '14'} $color={value === '' ? 'supportive' : 'default'}>
              {list.find((item) => String(item.value) === String(value))?.label || placeholder}
            </Text>
            <Icon
              name="Arrow"
              $transform={`rotate(${open ? '180deg' : '0deg'})`}
              $pathFill={open && 'primary600'}
              $pathOpacity={open && '1'}
            />
          </S.DropBox>
        </label>
        <S.List open={open} $maxHeight={$maxHeight}>
          {list.map((item, index) => (
            <S.ListItem key={`item_${index}`} onClick={() => handleOnChange(item)}>
              <Text
                $color={String(item.value) === String(value) && 'primary600'}
                $type={String(item.value) === String(value) && 'b'}
              >
                {item.label}
              </Text>
            </S.ListItem>
          ))}
        </S.List>
      </S.Container>
    </S.Warp>
  );
}
